<script setup>
import { computed } from "vue";
import { DialogRoot } from "radix-vue";

const props = defineProps({
  open: Boolean,
  defaultOpen: Boolean,
  modal: Boolean,
});

const emits = defineEmits(["update:open"]);

const forwarded = computed(() => {
  return {
    open: props.open,
    defaultOpen: props.defaultOpen,
    modal: props.modal,
  };
});
</script>

<template>
  <DialogRoot v-bind="forwarded" @update:open="emits('update:open', $event)">
    <slot />
  </DialogRoot>
</template>
